import { QueryParams } from "@/models/query-params.model";
import { ClassesRest } from "@/services/rest/classes.rest";
import { GenericsUtils } from "@/utils/generics.util";
import { BehaviorSubject, map, take } from "rxjs";

export enum Status {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}
export class ClassesService {
  constructor(private _classes = new ClassesRest()) {}

  private class$ = new BehaviorSubject([]);
  class = this.class$.asObservable();

  private classes$ = new BehaviorSubject([]);
  classes = this.classes$.asObservable();

  getAllClasses(params: QueryParams): void {
    this._classes
      .getAllClasses(params)
      .pipe(
        map((e) => {
          e.content = e.content.map((item: any) => {
            return {
              id: item.id,
              name: item.name,
              studentsAverage: item.users?.length,
              coursesAverage: item.coursesIds?.length,
              status: this.remakeObjectStatus(
                item.disabled ? Status.INACTIVE : Status.ACTIVE
              ),
            };
          });
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.classes$.next(response);
        },
      });
  }

  getClassById(classId: string): void {
    this._classes
      .getClassById(classId)
      .pipe(
        take(1),
        map((e) => {
          e.users = e.users.map((user) => user.id);
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.class$.next(response);
        },
      });
  }

  getStatus(status: string): string {
    if (status == Status.ACTIVE) {
      status = GenericsUtils.translateI18n("classes.status.enabled");
    } else if (status == Status.INACTIVE) {
      status = GenericsUtils.translateI18n("classes.status.disabled");
    }
    return status;
  }

  getStatusColor(status: string): string {
    if (status == Status.INACTIVE) {
      status = "bg-h-secondary-200 text-h-secondary-800";
    } else if (status == Status.ACTIVE) {
      status = "bg-h-success-50 text-h-success-500";
    }
    return status;
  }

  remakeObjectStatus(item: any): any {
    var status = { name: "", class: "", value: "" };
    status.name = this.getStatus(item);
    status.class = this.getStatusColor(item);
    status.value = item;
    return status;
  }

  statusChange(status: string): string {
    switch (status) {
      case Status.ACTIVE:
        return Status.INACTIVE;
      case Status.INACTIVE:
        return Status.ACTIVE;
    }
    return status;
  }
}
